<template>
  <div class="page-container">
    <van-nav-bar fixed left-arrow title="我的专享" z-index="10" @click-left="$router.push({ path: '/user' })">
    </van-nav-bar>
    <div class="the-top">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list class="tian-deail list" v-model="loading" :immediate-check="true" :finished="finished" :finished-text="finishedText" :error.sync="error" error-text="请求失败，点击重新加载" @load="getMoreProduct">
          <div v-for="item in product_list" :key="item.id" class="tian-deail">
            <div class="tian-item" @click.stop.prevent="onToDetail(item)">
              <div class="tian-item-main" :class="{
                  'sold-out': item.isFull || item.serverTime >= item.endTime
                }">
                <div class="product-information">
                  <!-- title -->
                  <div class="title">
                    <span>{{ item.name }}</span>
                    <van-tag class="points" v-if="item.scoreRate > 0">返积分</van-tag>
                    <img v-if="
                        (item.productLevel === 1 || item.productLevel === 2) &&
                        item.serverTime <= item.endTime
                      " class="hot-tag" src="../../assets/img/hot.png" alt />
                  </div>
                  <!-- tag -->
                  <div class="tag">
                    <van-tag class="tag1" v-if="item.label1" :class="{ hide: !item.label1 || item.label1.length < 1 }" plain color="#ff9900">{{ item.label1 }}</van-tag>
                    <van-tag v-if="item.label2" class="tag2" :class="{ hide: !item.label1 || item.label1.length < 1 }" plain color="#ff9900">{{ item.label2 }}</van-tag>
                    <van-tag v-if="item.attachLabel" plain color="#ff9900">{{
                      item.attachLabel
                    }}</van-tag>
                  </div>
                  <!-- data -->
                  <div class="data">
                    <!-- gain -->
                    <div class="gain">
                      <template v-if="item.ifStair">
                        <b>{{ rateInterval(item).minRate }}</b>
                        <span>%</span>
                        <span class="fuhao">~</span>
                        <b>{{ rateInterval(item).maxRate }}</b>
                        <span>%</span>
                      </template>
                      <template v-else>
                        <b>{{ item.expectedRate }}</b>
                        <span>%</span>
                        <template v-if="item.greenhandRate && item.greenhandRate > 0">
                          <span class="fuhao">+</span>
                          <b>{{ item.greenhandRate }}</b>
                          <span>%</span>
                        </template>
                      </template>
                      <!-- text -->
                      <div class="txt">预期年化收益率</div>
                    </div>
                    <!-- term -->
                    <div class="term">
                      <div class="term-box">
                        <!-- day -->
                        <div class="day">
                          <span class="s1">{{ item.investDuration }}</span>
                          <span class="s2">天</span>
                        </div>
                        <!-- text -->
                        <div class="txt">
                          <!-- {{ item.miniAmount / 1000000 }}万元起投 -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- progress -->
                  <div class="progress">
                    <div class="progress-box">
                      <!-- progress-style -->
                      <div class="progress-style">
                        <div v-if="item.isFull || item.serverTime >= item.endTime" class="progress-pivot" style="width: 100%"></div>
                        <div v-else class="progress-pivot" :style="{ width: item.sold + '%' }"></div>
                      </div>
                      <!-- result -->
                      <div class="result">{{ progressText(item) }}</div>
                    </div>
                  </div>

                  <!-- 标签 -->
                  <div class="aside" color="#fc6524" size="large" v-if="
                      item.saleLabel === '1' && item.isFull <= item.endTime
                    ">
                    新手专享
                  </div>

                  <div :class="_isOnlyShowShuang11Icon() ? 'label-img' : 'aside'" color="#fc6524" size="large" v-if="
                      (item.saleLabel === '2' || item.productLevel === 1) &&
                      item.serverTime <= item.endTime
                    ">
                    <img v-if="_isOnlyShowShuang11Icon()" style="width: 35px" class="hot-tag" src="../../assets/img/common/shuang11-rate.jpg" alt />
                    <span v-else>{{ item.hotRate ? "热销加息" : "人气产品" }}</span>
                  </div>
                  <div class="aside" color="#fc6524" size="large" v-if="
                      item.saleLabel === '4' && item.serverTime <= item.endTime
                    ">
                    秒杀
                  </div>
                  <div class="aside" v-if="
                      item.productLevel === 2 && item.serverTime <= item.endTime
                    ">
                    加息
                  </div>
                  <div v-if="item.serverTime >= item.endTime" class="signet-sold-out">
                    已结束
                  </div>
                  <div v-if="item.isFull" class="signet-sold-out">已售罄</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 无数据，显示空 -->
          <van-empty description="暂无产品" v-if="product_list.length == 0"></van-empty>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 第九部分 风险测评 -->
    <van-popup class="assess-dialog" v-model="assessShow">
      <h2 class="mt-0 fs-xxl ta-c">您还没有完成风险测评</h2>
      <div class="mb-20">
        根据相关法规，买入前先进行测评，以便了解自身的风险承受能力，做出理性投资决策
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
    <!-- 风险测评是否强制显示重新测评 -->
    <van-popup class="assess-dialog" v-model="resetAssessShow">
      <h2 class="mt-0 fs-xxl ta-c">温馨提示</h2>
      <div class="mb-20">
        您好！您之前的风险测评已到期，需要重新进行风险测评，请前往测评！
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js" />
<script>
import * as ProductApi from "@/api/product"
import * as ShareApi from "@/api/share"
import * as CustApi from "@/api/cust"
import { mapGetters, mapActions, mapMutations } from "vuex"
import session from "@/utils/session"
import { Toast, Tag, List, Empty, PullRefresh, Popup, Dialog } from "vant"

export default {
  name: "myexclusive",
  components: {
    [Toast.name]: Toast,
    [PullRefresh.name]: PullRefresh,
    [Tag.name]: Tag,
    [List.name]: List,
    [Empty.name]: Empty,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog
  },

  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      finishedText: "",
      product_list: [],
      form: {
        investDuration: "all",
        pageNo: 1,
        pageSize: 10,
        sectionId: ""
      },
      assessShow: false,
      resetAssessShow: false,

      isShowShare: false,
      share: {
        title: "", //标题
        desc: "", //描述
        imgUrl:
          "https://tianbaolian.oss-cn-shanghai-finance-1-pub.aliyuncs.com/baolian/2021120810/17b30c56-17d4-4f40-8d18-1343cf613dde.jpg",
        link: location.href.split("#")[0]
      }
    }
  },

  computed: {
    ...mapGetters(["channel", "os", "token", "userInfo"])
  },

  created() {
    setTimeout(() => {
      wx.hideAllNonBaseMenuItem()
    }, 1000)
    this.getUserInfo()
      .then((data) => {
        if (!data) {
          Toast("服务器繁忙, 请稍后再试")
          return
        }
        this.setUserInfo(data)
        // this.onNormalLook()
      })
      .catch((e) => {
        this._dismissLoading()
        Toast(e.msg || e.message)
      })
    if (
      this.$route.query.sectionId &&
      this.userInfo.isAuthName &&
      this.userInfo.isBindCard &&
      (this.userInfo.userLevel > 0 || !this.userInfo.forceAssess)
    ) {
      this.onSectionProductPreach(this.$route.query.sectionId)
    }
  },

  methods: {
    ...mapActions(["getUserInfo"]),
    ...mapMutations(["setUserInfo"]),
    isSoldOut(n) {
      return n.isFull || n.serverTime >= n.endTime
    },
    // 利率
    rateInterval: function (n) {
      // console.info(n)
      if (n.ifStair) {
        let stairRate = n.stairRate
        let minRate = 10000,
          maxRate = 0
        let keys = ["One", "Two", "Three", "Four", "Five", "Six"]
        keys.forEach((k) => {
          if (stairRate["rate" + k]) {
            if (minRate > n.stairRate["rate" + k]) {
              minRate = n.stairRate["rate" + k]
            }
            if (maxRate < n.stairRate["rate" + k]) {
              maxRate = n.stairRate["rate" + k]
            }
          }
        })
        return { minRate: minRate, maxRate: maxRate }
      }
    },

    onRefresh() {
      this.form.pageNo = 1
      this.getMoreProduct()
    },

    getMoreProduct() {
      let the = this
      let timeout = 1000
      // 每次加载不超过15个产品，下拉加载更多
      this.form.sectionId = this.$route.query.sectionId || ""
      ProductApi.list(this.form)
        .then((data) => {
          the.loading = false
          if (the.form.pageNo == 1) {
            the.finished = false
            the.product_list = []
            the.product_list = data.list
          } else {
            the.product_list = the.product_list.concat(data.list)
          }
          if (the.form.pageNo == 1 && data.list.length == 0) {
            the.finishedText = "暂无产品"
          } else if (data.list.length < the.form.pageSize) {
            the.finishedText = "已经到底了"
            the.finished = true
          }
          the.form.pageNo++
          the.refreshing = false
        })
        .catch((e) => {
          the.loading = false
          the.refreshing = false
          the.finished = true
          the.error = true
          Toast(e.msg || e.message)
        })
    },

    onToDetail(product) {
      this.$router.push({
        path: "/detail",
        query: { productId: product.id, isExclusive: true }
      })
    },
    progressText: function (item) {
      if (item.isFull || item.serverTime >= item.endTime) {
        return "100%"
      } else {
        if (item.sold > 90) {
          return "即将售罄"
        } else if (item.sold < 10) {
          return "新开抢中"
        } else {
          return item.sold + "%"
        }
      }
    },

    //判断是否已经完成基本信息的操作
    onNormalLook() {
      if (this.userInfo.isAuthName) {
        this.resetAssessShow =
          this.userInfo.userLevel > 0 ? this.userInfo.forceAssess : false
        if (this.userInfo.userLevel < 1) {
          session.setJson("cq", {
            sectionId: this.form.sectionId,
            target: "myexclusive"
          })
          this.assessShow = this.resetAssessShow == true ? false : true
          return false
        }
        //检测绑卡
        if (!this.userInfo.isBindCard) {
          Dialog.alert({
            title: "温馨提示",
            message: "您还未绑卡，请先去绑卡？",
            confirmButtonText: "去绑卡",
            showCancelButton: true,
            theme: "round-button"
          })
            .then(() => {
              session.setJson("cq", {
                sectionId: this.form.sectionId,
                target: "myexclusive"
              })
              this.$router.push({ name: "bindcard" })
            })
            .catch(() => { })
          return false
        }
        return true
      } else {
        //未设置实名
        Dialog.alert({
          title: "温馨提示",
          message: "您还未实名，请先去实名认证？",
          confirmButtonText: "去实名",
          showCancelButton: true,
          theme: "round-button"
        })
          .then(() => {
            session.setJson("cq", {
              sectionId: this.form.sectionId,
              target: "myexclusive"
            })
            this.$router.push({ name: "realname" })
          })
          .catch(() => { })
        return false
      }
    },
    goAssess() {
      session.setJson("cq", {
        sectionId: this.form.sectionId,
        target: "myexclusive"
      })
      this.$router.push({ path: "/questions" })
    },
    onSectionProductPreach(sectionId) {
      CustApi.sectionProductPreach(sectionId)
        .then((data) => {
          if (data) {
            console.log("data == %O", data)
            if (data.share) {
              if (this.isWechant()) {
                setTimeout(() => {
                  wx.showAllNonBaseMenuItem()
                  this.isShowShare = data.share
                  this.getSectionInfo(sectionId)
                }, 1000)
              }
            }
          }
        })
        .catch((e) => {
          Toast(e.msg || e.message)
        })
    },
    getSectionInfo(sectionId) {
      CustApi.sectionInfo(sectionId)
        .then((data) => {
          this.share.title = data.shareTitle || ""
          this.share.desc = data.shareDesc || ""
          if (data.shareImg) {
            this.share.imgUrl = data.shareImg
          }
          this.share.link =
            this.share.link +
            "#/myexclusive?sectionId=" +
            sectionId +
            "&referrerCod=" +
            this.userInfo.custAccount.custId +
            "&referrerType=SECTION"
          this.initShareConfig()
        })
        .catch((e) => {
          Toast(e.msg || e.message)
        })
    },
    initShareConfig() {
      let url = location.href.split("#")[0]
      ShareApi.getSignature({
        url: url
      })
        .then((data) => {
          //通过config接口注入权限验证配置  只要调后端接口就可以了。后端会把那些信息处理好，然后通过一个接口返给你这些参数
          //拼接sha1加密字符串
          if (this.isWechant()) {
            wx.config({
              // development production
              // debug: true,
              debug: process.env.NODE_ENV == "development",
              // debug: process.env.NODE_ENV != "production", // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              timestamp: data.timestamp,
              appId: data.appid, // 必填，公众号的唯一标
              nonceStr: data.noncestr, // 必填，生成签名的时间戳
              signature: data.signature, // 必填，生成签名的随机串
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData"
              ] // 必填，需要使用的JS接口列表
            })
            //通过ready接口处理成功验证
            wx.ready(() => {
              //需在用户可能点击分享按钮前就先调用
              //分享到朋友圈"
              wx.updateTimelineShareData({
                title: this.share.title,
                link: this.share.link, // 分享链接
                imgUrl: this.share.imgUrl, // 分享图标
                success: function (res) {
                  console.log("分享朋友圈成功")
                },
                cancel: function (res) {
                  console.log("分享朋友圈失败")
                }
              })
              //分享给朋友
              wx.updateAppMessageShareData({
                title: this.share.title,
                link: this.share.link, // 分享链接
                imgUrl: this.share.imgUrl, // 分享图标
                desc: this.share.desc, // 分享描述
                success: function (res) {
                  console.log("分享好友成功")
                },
                cancel: function (res) {
                  console.log("分享好友失败")
                }
              })
            })
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    }
  },
  destroyed() {
    wx.showAllNonBaseMenuItem()
  }
}
</script>

<style lang="less" scoped>
.the-top {
  padding-bottom: 0;
}

// @import url('../idx.less');
// ::v-deep .van-tab {
//   color: #999;
// }

::v-deep .van-hairline--top-bottom:after {
  border: none;
}

::v-deep .van-tab {
  color: #999;
}

::v-deep .van-tab--active {
  color: #333;
  font-weight: 700;
}

::v-deep .van-tag--large {
  font-size: 12px;
  padding-left: 25px;
}

.tian-item-main {
  margin: 10px 13px;
  &.sold-out {
    filter: grayscale(0%) opacity(0.6);
  }
}

.product-information {
  position: relative;
  padding: 14px 12px;
  border-radius: 5px;
  background-color: #fff;

  // name
  .title {
    font-size: 16px;
    height: 1.5em;
    overflow: hidden;
    color: #333333;
    word-break: break-all;
    .points {
      margin-left: 5px;
      color: #ffffff;
      border-radius: 3px;
      background-color: #fc6524;
    }
    .hot-tag {
      width: 20px;
      margin-left: 15px;
    }
  }
  // tag
  .tag {
    //  margin-left: -6px;
    .van-hairline--surround::after {
      border: none;
    }
    .van-tag {
      font-size: 10px;
      margin-right: 3px;
    }
    .hide {
      display: none;
    }
    //  .tag1,.tag2 {
    //     margin-right: 5px;
    //  }
    div {
      display: inline-block;
      height: 8px;
      width: 0.8px;
      background-color: #ff9900;
    }
  }
  // data
  .data {
    display: flex;
    align-items: center;
    // text
    .txt {
      color: #999;
      font-size: 14px;
    }
    // gain
    .gain {
      flex: 1;
      b {
        font-size: 36px;
        color: #fc6524;
        font-weight: normal;
      }
      span {
        font-size: 15px;
        color: #fc6524;
        margin-left: 1px;
      }
      .fuhao {
        font-size: 18px;
        color: #fc6524;
        margin: auto 5px;
      }
    }
    // term
    .term {
      flex: 1;
      text-align: center;

      .term-box {
        height: 72px;
        padding-right: 40px;
        // day
        .day {
          height: 53px;
          line-height: 53px;
          color: #666;

          .s1 {
            font-size: 22px;
          }
          .s2 {
            font-size: 18px;
            margin-left: 2px;
          }
        }
      }
    }
  }
  // progress
  .progress {
    margin-top: 10px;
    .progress-box {
      display: flex;
      align-items: center;
      // title
      .title {
        font-size: 11px;
        color: #666;
        margin-top: 3px;
      }
      // progress-style
      .progress-style {
        width: 250px;
        height: 7px;
        line-height: 16px;
        position: relative;
        background-color: #e9e9e9;
        border-radius: 7px;
        overflow: hidden;
        .progress-pivot {
          box-sizing: border-box;
          height: 100%;
          background-color: #fc6524;
          border-radius: 7px;
        }
      }
      // result
      .result {
        font-size: 14px;
        margin-left: 10px;
        color: #666;
      }
    }
  }
  .aside,
  .signet-sold-out {
    position: absolute;
    top: 16px;
    right: 0px;
    padding: 0 12px;
    line-height: 24px;
    text-align: center;
    font-size: 13px;
    box-sizing: border-box;
    border-radius: 25px 0 0 25px;
    color: #fff;
  }
  .signet-sold-out {
    background-color: #d6d6d7;
  }
  // aside
  .aside {
    background-color: rgb(252, 101, 36);
  }
  .label-img {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 0;
  }
}

.assess-dialog {
  padding: 0.8rem;
  width: 70vw;

  .btn-assess {
    width: 70%;
    color: @golden;
    font-size: @font-size-xxl;
    border-color: @golden;
    border-radius: 5px;
  }
}
</style>